import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import * as Store from '../../store';

import template from './login.vue';

// Websockets
import { WebsocketsListener } from '../../utils/ws';

@Component({
    mixins: [template]
})

export default class Login extends Vue {

    private username: string = '';
    private password: string = '';


    wsListener: WebsocketsListener;

    constructor() {

        super();

        this.wsListener = new WebsocketsListener();

        // Assign session values to store for global dispatch
        this.wsListener.onPost('auth.login', (success: boolean, data: any) => {

            if (!success) {
                Store.commitLoaderVisibility(this.$store, false);
                return alert(data);
            }

            // Save the user data to localstorage
            this.wsListener.setAuthState(true, data);

            // Wait few ms to write the things
            setTimeout(() => {

                Store.commitLoggedInState(this.$store, true);
                Store.commitLoggedInUser(this.$store, data);

                this.wsListener.reconnect(() => {

                    if (this.$root.$options.router) {
                        this.$root.$options.router.push('/');
                    }

                });

            }, 100);

        });

    }

    doLogin() {

        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendPost('auth.login', {
            user: this.username,
            pass: this.password
        });

        return false;
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/login/index.ts